import { defineMessages } from '@alltrails/shared/react-intl';

const PRO_FEATURE_CAROUSEL_STRINGS = defineMessages({
  DISTANCE_AWAY_TITLE: {
    defaultMessage: 'Easily find trails near you'
  },
  DISTANCE_AWAY_DESCRIPTION: {
    defaultMessage: 'Spend less time getting there and more time outside when you search by distance away.'
  },
  DISTANCE_AWAY_ALT: {
    defaultMessage: 'A phone showing the "distance away" AllTrails+ feature'
  },
  MAP_DOWNLOAD_TITLE: {
    defaultMessage: "Go where mobile service can't"
  },
  MAP_DOWNLOAD_DESCRIPTION: {
    defaultMessage: 'Download maps ahead of time so you still have directions even without service.'
  },
  MAP_DOWNLOAD_ALT: {
    defaultMessage: 'A phone showing the "map download" AllTrails+ feature'
  },
  OFF_ROUTE_TITLE: {
    defaultMessage: 'Wander without getting lost'
  },
  OFF_ROUTE_DESCRIPTION: {
    defaultMessage: 'Off-route alerts will only ping if you veer off path so you can enjoy the views ahead. '
  },
  OFF_ROUTE_ALT: {
    defaultMessage: 'A phone showing the "off route alerts" AllTrails+ feature'
  }
});

export default PRO_FEATURE_CAROUSEL_STRINGS;
